import {
	invertedThemeColors,
	invertedThemeColorsNBD,
	mainThemeColors,
	mainThemeColorsNBD,
} from '@volkswagen-onehub/tokens';

const isNewBrandDesign = (): boolean => {
	return true;
};

export const COLOR_TOKEN = {
	main: {
		...(isNewBrandDesign() ? mainThemeColorsNBD : mainThemeColors),
	},
	inverted: {
		...(isNewBrandDesign() ? invertedThemeColorsNBD : invertedThemeColors),
	},
};
